import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormsModule, NgForm } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { DatetimePickerComponent } from '../../core/components/datetime-picker/datetime-picker.component';
import { DATE_FORMAT } from '../../core/constants/date';
import { BootstrapFormInputsDirective } from '../../core/directives/bootstrap-form-inputs.directive';
import { BootstrapFormDirective } from '../../core/directives/bootstrap-form.directive';
import { CustomRequiredValidatorDirective } from '../../core/directives/custom-required-validator.directive';
import { DatetimePickerValidatorDirective } from '../../core/directives/datetime-picker-validator.directive';
import { InvalidCharacterRemoverDirective } from '../../core/directives/invalid-character-remover.directive';
import { LoadingIndicatorDirective } from '../../core/directives/loading-indicator.directive';
import { Patient } from '../../core/models/patient';
import { ProviderGroup } from '../../core/models/provider-group';
import { AuthService } from '../../core/services/auth.service';
import { GlobalModalService } from '../../core/services/global-modal.service';
import { ManualPatientService } from '../../core/services/manual-patient.service';
import { ProviderGroupService } from '../../core/services/provider-group.service';

@Component({
  selector: 'th-update-manual-patient-info',
  templateUrl: './update-manual-patient-info.component.html',
  styleUrls: ['./update-manual-patient-info.component.scss'],
  imports: [
    BootstrapFormDirective,
    FormsModule,
    BootstrapFormInputsDirective,
    CustomRequiredValidatorDirective,
    InvalidCharacterRemoverDirective,
    DatetimePickerComponent,
    DatetimePickerValidatorDirective,
    LoadingIndicatorDirective
  ]
})
export class UpdateManualPatientInfoComponent implements OnInit {
  @ViewChild('form') ngForm: NgForm;
  @Input() patientDetails: Patient;
  @Input() memberId: string;

  submitting = false;
  loadingMedicalHomes = false;
  patient: Patient = new Patient();
  medicalHomes: ProviderGroup[] = [];
  dateFormat: string = DATE_FORMAT;

  constructor(
    public modalService: NgbModal,
    private toastr: ToastrService,
    private globalModalService: GlobalModalService,
    public authService: AuthService,
    private providerGroupService: ProviderGroupService,
    private manualPatientService: ManualPatientService
  ) {}

  ngOnInit() {
    this.loadPatientDetails();
    this.getMedicalHomes();
  }

  private loadPatientDetails() {
    if (this.patientDetails) {
      // Create a copy of patient details
      this.patient = { ...this.patientDetails };
    }
  }

  onSubmit() {
    this.submitting = true;

    this.manualPatientService
      .updateManualPatientInfo(this.patient)
      .pipe(finalize(() => (this.submitting = false)))
      .subscribe((data) => {
        if (data) {
          this.patient = data;
          this.modalService.dismissAll();
          this.toastr.success('Patient information updated successfully');
        } else {
          this.globalModalService.alert({
            bodyText: 'Failed to update patient information'
          });
        }
      });
  }

  private getMedicalHomes() {
    this.loadingMedicalHomes = true;
    this.providerGroupService
      .fetchProviderGroups(this.authService.orgId, this.authService.orgLevel, '', true, true)
      .pipe(finalize(() => (this.loadingMedicalHomes = false)))
      .subscribe((data) => {
        this.medicalHomes = data;

        // Set medical home by matching providergroupid
        if (this.patientDetails?.providergroupid) {
          const matchingMedicalHome = this.medicalHomes.find(
            (mh) => mh.providerGroupID === this.patientDetails.providergroupid
          );
          if (matchingMedicalHome) {
            this.patient.medicalHome = matchingMedicalHome.providerGroupID;
          }
        }
      });
  }

  closeModal() {
    this.modalService.dismissAll();
  }
}
